import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { ListingCard } from '@kamernet/modules/Listing/components/ListingCard';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './SimilarPlacesGrid.module.css';

const SimilarPlacesGridInternal = () => {
  const { listingDetails } = ListingDetailsContext.useContext();
  const isDesktop = useMediaIsDesktop();
  const { T, locale } = useIntl();

  return (
    listingDetails && (
      <div className={styles.root}>
        <div className={styles.header}>
          <Typography variant="h4">
            {T('ldp.similar_places_in', listingDetails.computedCityName)}
          </Typography>
          {isDesktop && (
            <NavLink.Anchor
              variant="body3Bold"
              href={ROUTES.ListingsSearchCity.getURL(
                {
                  city: listingDetails.citySlug,
                },
                locale,
              )}
            >
              {T('LBL_FB_SEE_ALL')}
            </NavLink.Anchor>
          )}
        </div>
        <div className={styles.container}>
          {listingDetails.suggestedListingResult.map(listing => (
            <ListingCard
              key={listing.listingId}
              listingId={listing.listingId}
              thumbnailUrl={listing.thumbnailUrl}
              fullPreviewImageUrl={listing.fullPreviewImageUrl}
              isTopAdvert={listing.isTopAdvert}
              furnishingId={listing.furnishingId}
              availabilityStartDate={listing.availabilityStartDate}
              availabilityEndDate={listing.availabilityEndDate}
              streetName={listing.street}
              streetSlug={listing.streetSlug}
              cityName={listing.city}
              citySlug={listing.citySlug}
              isFavorite={listing.isFavorite}
              surfaceArea={listing.surfaceArea}
              listingType={listing.listingType}
              totalRentalPrice={listing.totalRentalPrice}
              utilitiesIncluded={listing.utilitiesIncluded}
              isNewAdvert={listing.isNewAdvert}
              isReactForFree={listing.isReactForFree}
              isStudentHouseAdvert={listing.isStudentHouseAdvert}
            />
          ))}
        </div>
      </div>
    )
  );
};

export const SimilarPlacesGrid = React.memo(SimilarPlacesGridInternal);
